import {useState, useCallback} from 'react';
import {Platform} from 'react-native';
import FirebaseAnalytic from 'src/nativeModules/FirebaseAnalytic';
import SupportEmailService from 'src/services/SupportEmailService';
import Settings from 'src/Settings';
import Localized from 'src/constants/AppStrings';

export const useEmailSupport = () => {
  const [showErrorModal, setShowErrorModal] = useState(false);

  const handleContactClick = useCallback(() => {
    const appName =
      Platform.OS === 'web'
        ? Settings.webAppDisplayName
        : `${Settings.appDisplayName} App`;

    const subject = `${appName} Help Inquiry`;
    const body = Localized.Labels.help_details_prompt;

    FirebaseAnalytic.trackEvent('handleContactClick', 'HelpScreen', {
      subject,
      body,
    });

    SupportEmailService.createEmail(subject, body, () =>
      setShowErrorModal(true),
    );
  }, []);

  const hideModal = useCallback(() => setShowErrorModal(false), []);

  return {showErrorModal, handleContactClick, hideModal};
};
